import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import { message } from 'ant-design-vue'
import store from '@/store'
import { isString } from 'lodash-es'

const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
const Index = () => import(/* webpackChunkName: "index" */ '@/views/Index.vue')
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
const UserSetting = () => import(/* webpackChunkName: "userSetting" */ '@/views/UserSetting.vue')
const Works = () => import(/* webpackChunkName: "works" */ '@/views/Works.vue')
const Editor = () => import(/* webpackChunkName: "editor" */ '@/views/editor/Editor.vue')
const TemplateDetail = () => import(/* webpackChunkName: "templateDetail" */ '@/views/TemplateDetail.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        { path: '', name: 'home', component: Home, meta: { title: '欢迎来到 SMILE LEGO' } },
        { path: 'template/:id', name: 'template', component: TemplateDetail, meta: { title: '模版详情' } },
        { path: 'works', name: 'works', component: Works, meta: { title: '我的作品', requiredLogin: true } },
        { path: 'setting', name: 'setting', component: UserSetting, meta: { title: '个人设置', requiredLogin: true } }
      ]
    },
    {
      path: '/editor/:id',
      name: 'EditorWork',
      component: Editor,
      meta: { requiredLogin: true, title: '编辑我的设计' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { redirectAlreadyLogin: true, title: '登录到 SMILE LEGO', disableLoading: true }
    }
  ]
})

router.beforeEach(async to => {
  const { user } = store.state
  const { token, isLogin } = user
  const { redirectAlreadyLogin, requiredLogin, title } = to.meta
  if (isString(title)) {
    document.title = title
  }
  if (!isLogin) {
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
      try {
        await store.dispatch('fetchCurrentUser')
        if (redirectAlreadyLogin) {
          return '/'
        }
      } catch {
        message.error('登陆状态已过期 请重新登陆', 2)
        store.commit('logout')
        return '/login'
      }
    } else {
      if (requiredLogin) {
        return '/login'
      }
    }
  } else {
    if (redirectAlreadyLogin) {
      return '/'
    }
  }
})
export default router
